import {
  generalTerm,
} from './sk.shared.ts';

import npmTranslation from '@/generated/npm/locales/sk.npm.ts';
import {
  TComponentNpmKeys,
  TComponentNpmValue,
} from '@/types/openapi-type.ts';

const RBBEProcessMode_String: Record<TComponentNpmValue<'RBBEProcessMode_String'>, string> = {
  STANDBY: 'Pohotovosť',
  PROCESS: 'Proces',
  MAINTENANCE: 'Údržba',
  NO_PROCESS: 'Žiadny proces',
  EMERGENCY: 'Núdzový stav',
  ABORT: 'Prerušiť',
  PREHEAT: 'Predhriať',
  PURGE: 'Prepláchnuť',
  TRANSFER_IN: 'Príjem',
  TRANSFER_OUT: 'Výdaj',
  FINISHED: 'Dokončené',
  ERROR: 'Chyba',
};

const LoadJobDto: Record<keyof TComponentNpmValue<'LoadJobDto'>, string> = {
  recipe_code: generalTerm.recipe,
  customer_code: 'Kód zákazníka',
  customer_name: 'Meno zákazníka',
  operator_name: 'Operátor',
  shop_order: 'Zákazka',
  part_numbers: 'Čísla dielov (oddelené čiarkami)',
  part_count: 'Počet',
  job_start_time: 'Čas začiatku',
  comment: 'Komentár',
};

const RecipeListEntryDTO: Record<keyof TComponentNpmValue<'RecipeListEntryDTO'>, string> = {
  recipe_code: generalTerm.recipe,
  recipe_description: generalTerm.description,
  protected: 'Chránený',
};

const RecipeDTO: Partial<TComponentNpmKeys<'RecipeDTO', Record<string, string> | string>> = {
  description: generalTerm.description,
  duration_min: npmTranslation.resourceId[1028],
};

const StageDTO: Partial<TComponentNpmKeys<'StageDTO', Record<string, string> | string>> = {
  stage_no: '#',
  name: generalTerm.displayName,
  EndCond: npmTranslation.resourceId[1035],
};

export default {
  LoadJobDto,
  RBBEProcessMode_String,
  RecipeListEntryDTO,
  RecipeDTO,
  StageDTO,
};
